<template>
  <div class="policy-wrap">
    <span>{{ copyrightText }}</span>
    &nbsp;&nbsp;&nbsp;
    <span style="margin-right: 4px">© 2024 ChatGLM4 京公网安备11010802041394号</span>
    <el-popover :effect="isDarkMode ? 'dark' : 'light'" placement="top" width="300" trigger="hover">
      <div class="policy-wrap-text">
        网信算备110108105858001230019号<br />网信算备110108105858001230043号<br />网信算备110108105858001240071号<br />京ICP备20011824号-18<br />Beijing-ChatGLM-20230821
      </div>
      <template v-slot:reference>
        <span :class="['policy-icon', { 'policy-icon-dark': isDarkMode }]"></span>
      </template>
    </el-popover>
    &nbsp;
    <a class="link" target="_blank" href="https://chatglm.cn/agreement">用户协议</a>
    &nbsp;<span>|</span>&nbsp;
    <a class="link" target="_blank" href="https://chatglm.cn/privacypolicy">隐私政策</a>&nbsp;
  </div>
</template>

<script>
import { COPYRIGHT_TEXT } from '@/utils/constant'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
const copyrightText = ref(COPYRIGHT_TEXT)
export default {
  name: 'Policy',
  setup() {
    const store = useStore()
    const isDarkMode = computed(() => store.state.DarkMode.isDarkMode)
    return {
      copyrightText,
      isDarkMode
    }
  }
}
</script>

<style lang="less">
.el-popper.is-light {
  background: var(--bg_floating_white_1, #2f3031);
  border: 1px solid var(--floating_stroke_grey_1, #f5f5f5);
}
.policy-wrap {
  padding-top: 12px;
  span {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: var(--txt_icon_grey_6, #b0b7c0);
  }
  .link {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: var(--txt_icon_grey_6, #b0b7c0);
    &:hover {
      color: var(--txt_icon_grey_5, #838a95);
      text-decoration-line: underline;
    }
  }
  .policy-wrap-text {
    font-size: 12px;
    background: var(--bg_white_1, #ffffff);
  }
  .policy-icon {
    position: relative;
    top: 1px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url('~@/assets/image/policy_icon.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    &.policy-icon-dark {
      background-image: url('~@/assets/image/policy_icon-dark.png');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
    &:hover {
      cursor: pointer;
      background-image: url('~@/assets/image/policy_icon_hover.png');
    }
  }
}
:deep(.el-popper__arrow:before) {
  background: var(--tips_toast_black_1, #1a2029) !important;
}
</style>
